export default class Instruction {
    constructor () {
        this.name = "Instruction";
        this.uniqueID = "";

        this.autoload = true;
        this.loaded = false;
        this.s = { children : {} }; // Fixed state
        this.a = {}; // Auxiliary state - members to be binned on unload

        this.children = {};
        this.childrenorder = [];

        this.sideeffectcleanup = [];
    }

    attach (child) {
        var name = child.name;
        if (name === undefined) name = "";

        child.uniqueID = this.provideUniqueIdentifier(name);
        this.children[child.uniqueID] = child;
        this.childrenorder.push(child.uniqueID);

        child.parent = this;

        if (this.game) child.attachToGame(this.game);

        if (this.loaded && child.autoload) child.load();

        return this;
    }

    detach (uniqueID) {
        if (this.children[uniqueID] == undefined) return;

        var child = this.children[uniqueID];
        if (child.loaded) child.unload();

        this.childrenorder.splice(this.childrenorder.indexOf(uniqueID), 1);
        child.uniqueID = null;

        child.parent = null;

        if (child.game) child.detachFromGame();

        delete this.children[uniqueID];

        return this;
    }

    attachToGame (game) {
        this.game = game;

        for (var i = 0; i < this.childrenorder.length; ++i) {
            this.children[this.childrenorder[i]].attachToGame(game);
        }
    }

    detachFromGame () {
        this.game = null;

        for (var i = 0; i < this.childrenorder.length; ++i) {
            this.children[this.childrenorder[i]].detachFromGame();
        }
    }

    load () {
        if (this.loaded || this.game === undefined) return;

        for (var i = 0; i < this.childrenorder.length; ++i) {
            var child = this.children[this.childrenorder[i]];
            if (child.autoload) child.load();
        }

        if (this.parent) this.parent.s.children[this.uniqueID] = this.s;

        this.setup();

        this.loaded = true;
    }

    unload () {
        if (!this.loaded) return;

        for (var i = this.sideeffectcleanup.length - 1; i >= 0; --i) {
            this.sideeffectcleanup[i]();
        }

        this.cleanup();

        if (this.parent) delete this.parent.s.children[this.uniqueID];

        this.a = {};

        for (var i = this.childrenorder.length - 1; i >= 0; --i) {
            this.children[this.childrenorder[i]].unload();
        }

        this.loaded = false;
    }

    setup () {}
    /**
     * Get rid of anything you couldn't do with external for whatever reason
     */
    cleanup () {}

    external (action, cleanup) {
        this.sideeffectcleanup.push(cleanup);
        action();
    }

    provideUniqueIdentifier (name) {
        if (this.children[name] === undefined) return name;
        else {
            var i = 1;
            while (this.children[name+i] !== undefined) ++i;
            return name+i;
        }
    }

    updateState () {}
    updateAuxiliary () {}
}
